import {addPutMethodToForm, post} from '../utils'
import {makeFormData, root} from './utils'

export default host => ({
  id,
  translations,
  slug,
  image,
                          showOnSmartSearch,
  limit,
  isTalent,
  type,
  synonyms,
  brand,
}) =>
  post(`${host}${root}/${id}`, addPutMethodToForm(makeFormData({
    translations,
    slug,
    image,
    showOnSmartSearch,
    limit,
    isTalent,
    type,
    synonyms,
    brand,
  })))
    .then(response => response.json())
